// CSS equivalent of Flutter's SliverGridDelegateWithMaxCrossAxisExtent.
//
// Flutter picks the column count as ceil(width / maxCrossAxisExtent), so every
// tile ends up AT MOST maxExtent wide. Plain CSS `auto-fill` does the opposite
// (floor), which yields one column fewer and noticeably bigger tiles — so the
// count is measured and computed here instead, giving the same layout as the
// Flutter screens at any width.

import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';

export default function ExtentGrid({
  maxExtent,
  childAspectRatio = 1,
  gap = 10,
  sx,
  children,
}) {
  const ref = useRef(null);
  const [cols, setCols] = useState(2);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const measure = () => {
      const w = el.clientWidth;
      if (w > 0) setCols(Math.max(1, Math.ceil(w / maxExtent)));
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [maxExtent]);

  return (
    <Box
      ref={ref}
      sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
        gap: `${gap}px`,
        ...sx,
      }}
    >
      {React.Children.map(children, (child) => (
        <Box sx={{ aspectRatio: String(childAspectRatio), minWidth: 0 }}>{child}</Box>
      ))}
    </Box>
  );
}
